import { useCallback, useRef } from 'react';
import { Flex, RootScreen } from '@banhala/ui-kit';
import {
  useHasBeenFocusedTab,
  useInstanceId,
  useNativeScrollSync,
  useNativeScrollToTop,
} from 'shared/src/hooks';
import {
  MarketRanking,
  type MarketRankingHandle,
} from './components/MarketRanking';

/**
 * 임시 테스트용. 홈탭 실험이 모두 완료되면. Home.screen.tsx로 통합 될 예정
 * @constructor
 */
export const MarketRankingScreen = () => {
  const instanceId = useInstanceId();
  const { hasBeenFocused, setHasBeenFocused } = useHasBeenFocusedTab();

  const rankingRef = useRef<MarketRankingHandle>(null);

  // native HomePagerVC 의 floating button 토글 + scrollToTop 동기화.
  // RN 스크롤 → onScrollEvent → animateFloatingButton (ReactNativeEmbeddedVC.swift)
  const { onScroll: onScrollSync } = useNativeScrollSync({ instanceId });

  const scrollToTop = useCallback(() => {
    rankingRef.current?.scrollToTop();
  }, []);

  useNativeScrollToTop({ onScrollToTop: scrollToTop, screen: 'MARKET_RANKING' });

  return (
    <RootScreen>
      <Flex
        flex={1}
        onPress={() => {}}
        onPressIn={() => setHasBeenFocused(true)}
      >
        {hasBeenFocused && (
          <MarketRanking ref={rankingRef} onScrollY={onScrollSync} />
        )}
      </Flex>
    </RootScreen>
  );
};
